module.exports = __webpack_public_path__ + "static/media/eli-lilly.bc413fd3.jpg";